
<h1 class='save-line-head' i18n='@@itemMenu-Transaction'>Test transazioni</h1>
<h4 i18n='@@text-createtransaction'>Crea una transazione di prova.</h4>

<!-- Init Form -->
<ng-container>
  <app-init-form></app-init-form>
</ng-container>
